// removed by extract-text-webpack-plugin
module.exports = {"delete-button":"DeleteAccessKey__delete-button___34ytO"};